import React from 'react'
import PropTypes from 'prop-types'
import BasicTable from '../../../../../../atoms/BasicTable'

function PredicatesDisplay ({ masterPredicate, subordinatePredicates = [] }) {
  return (
    <div style={{ marginBottom: '16px' }}>
      <h4>Predicates</h4>

      {/* Master Predicate */}
      <div style={{ marginBottom: '12px' }}>
        <h5>Master Predicate</h5>
        <div style={{
          padding: '8px',
          backgroundColor: 'var(--bg-color-subtle)',
          fontFamily: 'var(--font-mono)',
          fontSize: 'var(--text-size-sm)',
          borderRadius: '4px'
        }}
        >
          {masterPredicate.expression || 'None'}
        </div>
        {masterPredicate.requiredParams && masterPredicate.requiredParams.length > 0 && (
          <p style={{ fontSize: 'var(--text-size-sm)', color: 'var(--text-color-subtle)', marginTop: '4px' }}>
            Parameters: {masterPredicate.requiredParams.join(', ')}
          </p>
        )}
      </div>

      {/* Subordinate Predicates */}
      {subordinatePredicates.length > 0 && (
        <div>
          <h5>Subordinate Predicates ({subordinatePredicates.length})</h5>
          <BasicTable className='opal-presentation-table zebra-rows secondary'>
            <thead className='opt-thead'>
              <tr className='opt-tr'>
                <th className='opt-th'>Code</th>
                <th className='opt-th'>Description</th>
                <th className='opt-th'>Expression</th>
              </tr>
            </thead>
            <tbody className='opt-tbody'>
              {subordinatePredicates.map((pred, idx) => (
                <tr className='opt-tr' key={idx}>
                  <td className='opt-td'>{pred.code}</td>
                  <td className='opt-td'>{pred.description || '-'}</td>
                  <td className='opt-td' style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-size-sm)' }}>
                    {pred.expression}
                  </td>
                </tr>
              ))}
            </tbody>
          </BasicTable>
        </div>
      )}
    </div>
  )
}

PredicatesDisplay.propTypes = {
  masterPredicate: PropTypes.object.isRequired,
  subordinatePredicates: PropTypes.array
}

PredicatesDisplay.defaultProps = {
  subordinatePredicates: []
}

export default PredicatesDisplay
